import React from 'react';
import { Form } from 'react-bootstrap';
import { ChangeHighlighter, FormattedNumberInput, Table } from '@rd-web-markets/shared/dist/util';
import { useTranslation } from 'react-i18next';
const InitialAmountTable = _ref => {
  let {
    contractor,
    handleChange,
    applicationSubmitted,
    contractorType,
    handleSubmit
  } = _ref;
  const {
    t
  } = useTranslation();
  const rows = [{
    columns: [t('initial_amount'), /*#__PURE__*/React.createElement(ChangeHighlighter, {
      as: FormattedNumberInput,
      thousandSeparator: ".",
      decimalSeparator: ",",
      onChange: handleChange,
      onBlur: () => handleSubmit(false),
      object: contractor,
      name: "initial_amount",
      type: "text",
      size: "md",
      disabled: applicationSubmitted && contractorType === 'bfsz',
      onlyPositiveNumbers: true
    })]
  }, {
    columns: [t('total_included'), /*#__PURE__*/React.createElement(ChangeHighlighter, {
      as: FormattedNumberInput,
      thousandSeparator: ".",
      decimalSeparator: ",",
      object: contractor.cost_calculations,
      name: "total_of_all_years",
      type: "text",
      size: "md",
      disabled: true
    })]
  }, {
    columns: [t('remaining'), /*#__PURE__*/React.createElement(ChangeHighlighter, {
      as: FormattedNumberInput,
      thousandSeparator: ".",
      decimalSeparator: ",",
      object: {
        remaining: contractor.initial_amount - contractor.cost_calculations.total_of_all_years
      },
      name: "remaining",
      type: "text",
      size: "md",
      disabled: true
    })]
  }];
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Table, {
    headers: [],
    rows: rows,
    showControls: false
  }));
};
export default InitialAmountTable;